<div id="panel-control" class="page-layout simple fullwidth">
    <div fxLayout="row wrap" class="p-24">
        <div [@onRenderUp] class="fuse-card card-border-top card-fullwidth">
            <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="onChangeTab($event)">
                <mat-tab fxFlex="33" label="{{ 'evaluation.tab.pending' | translate }}"> </mat-tab>
                <mat-tab fxFlex="33" label="{{ 'evaluation.tab.completed' | translate }}"> </mat-tab>
                <mat-tab fxFlex="33" label="{{ 'evaluation.tab.total' | translate }}"> </mat-tab>
            </mat-tab-group>

            <!-- Filters -->
            @if (isBoss) {
                <div class="p-36 filter-container" fxLayout="row">
                    <div fxLayout="column" fxFlex="5 1 0">
                        <div fxLayout="row wrap" class="statics-filters">
                            <mat-form-field subscriptSizing="dynamic" dense appearance="outline" class="mr-8">
                                <mat-label>{{ "evaluation.controlpanel.period" | translate }}</mat-label>
                                @if (periodList().length) {
                                    <mat-select
                                        class="form-control"
                                        #filterPeriod
                                        [(value)]="selectedPeriod"
                                        (selectionChange)="onChangePeriod(filterPeriod.value)"
                                    >
                                        @for (period of periodList(); track period) {
                                            <mat-option [value]="period.id">{{ period.name }}</mat-option>
                                        }
                                    </mat-select>
                                }
                            </mat-form-field>
                            <mat-form-field subscriptSizing="dynamic" dense appearance="outline" class="mr-8">
                                <mat-label>{{ "evaluation.controlpanel.departament" | translate }}</mat-label>
                                <input
                                    class="form-control pointer"
                                    type="text"
                                    placeholder="{{ 'evaluation.controlpanel.departament' | translate }}"
                                    matInput
                                    [formControl]="formControl"
                                    [matAutocomplete]="auto"
                                />
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectDepartament()">
                                    @for (dep of filteredDepartaments | async; track dep) {
                                        <mat-option class="auto-option" [value]="dep.departamento">
                                            {{ dep.departamento }}
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                                @if (selectedDepartament) {
                                    <button
                                        class="dep-clear-btn"
                                        matIconSuffix
                                        mat-icon-button
                                        aria-label="Clear"
                                        (click)="clearDepartament()"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                }
                            </mat-form-field>
                            <mat-form-field subscriptSizing="dynamic" dense appearance="outline" class="mr-8">
                                <mat-label>{{ "evaluation.controlpanel.puesto" | translate }}</mat-label>
                                <mat-select
                                    class="form-control"
                                    #filterPuesto
                                    [(value)]="selectedPuesto"
                                    (selectionChange)="onChangePuesto(filterPuesto.value)"
                                >
                                    <mat-option value="">{{ "evaluation.filter.job.any" | translate }}</mat-option>
                                    @for (job of jobsList(); track job) {
                                        <mat-option [value]="job.id">{{ job.puesto }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <!-- Aspects -->
                        @if (currentPeriod()?.isEnabledEvaluationAspect) {
                            <div fxLayout="row wrap" style="margin-top: 20px">
                                @for (aspect of aspectsList(); track aspect) {
                                    <div>
                                        @if (aspect.type === "SELECT") {
                                            <mat-form-field
                                                subscriptSizing="dynamic"
                                                dense
                                                appearance="outline"
                                                class="mr-8"
                                            >
                                                <mat-label>{{ aspect.name }}</mat-label>
                                                <mat-select class="form-control" [(value)]="selectedAspect[aspect.id]">
                                                    <mat-option value="" (click)="onChangeAspect(aspect.id, '')"
                                                        >Cualquier {{ aspect.name }}</mat-option
                                                    >
                                                    @for (value of aspect.values; track value) {
                                                        <mat-option
                                                            [value]="value.id"
                                                            (click)="onChangeAspect(aspect.id, value.id)"
                                                            >{{ value.name }}</mat-option
                                                        >
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    <div fxLayout="column" fxFlex="1 1 0" fxLayoutAlign="flex-end">
                        <div (click)="applyFilters()">
                            <button class="p-8 action-button pointer">{{ "evaluation.filter.btn" | translate }}</button>
                        </div>
                    </div>
                </div>
            }

            @if (isBoss) {
                <div fxLayout="row wrap" fxLayoutAlign="space-between" class="notification-container">
                    @if (evaluations().length) {
                        <span>{{ evaluations().length }} evaluaciones</span>
                    }
                    <div (click)="sendAllPendingsEvaluationsMail()">
                        @if (project()?.id != 453) {
                            <button class="p-8 action-button pointer">
                                {{ "evaluation.modal.notifyAllUsers" | translate }}
                            </button>
                        }
                    </div>
                </div>
            }

            <!-- Evaluations -->
            @if (evaluationsLoaded) {
                <div [@slideUpList] fxLayout="row wrap" fxLayoutAlign="center center" class="p-36 cards-container">
                    @for (eval of evaluations(); track eval) {
                        <div
                            fxLayout="column"
                            [ngClass]="
                                eval.personId == user.id
                                    ? 'fuse-card card-border-top card-auto'
                                    : 'fuse-card card-border-top card-colaborador'
                            "
                        >
                            <!-- <mat-icon *ngIf="eval.personId == user.id" class="icon-badge secundary-text">bookmark</mat-icon> -->
                            @if (eval.personId == user.id) {
                                <div class="autoev-box" fxLayout="row" fxLayoutAlign="center flex-start">
                                    Autoevaluación
                                </div>
                            }
                            <colaborator-card
                                [isDoneTab]="selectedIndex == 1 ? true : false"
                                [evaluation]="eval"
                                [period]="currentPeriod()"
                                [aspectsList]="aspectsList()"
                                [userId]="user.id"
                                [projectName]="project()?.name"
                            ></colaborator-card>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
